import Image from './_image.js'
import AbsolutePane from './_absolute-pane.js'
import ConfigurableText from './_configurable-text.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import SelectableButton from './_selectable-button.js'

export default {
  name: 'LinkMenu',
  values: {
    showCompactLayout: false,
    showExtraItemDetails: false,
    showHeader: true,
    marginBottom: '10px',
    _mobile_marginBottom: '5px',
    icon: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '24px',
          minHeight: '24px',
          padding: '0 0 0 8px',
        },
      },
    },
    iconContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          top: 0,
          left: 0,
          bottom: 0,
        },
      },
    },
    extraItemDetails: {
      style: {
        flex: 0,
        padding: '0 0 0 8px',
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
      text: ' > ',
    },
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          padding: '8px',
          boxSizing: 'border-box',
        },
      },
    },
    header: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    subHeaderContainer: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          padding: '8px',
          boxSizing: 'border-box',
        },
      },
    },
    subHeader: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    regularContainer: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          flexDirection: 'column',
        },
      },
    },
    regularItem: {
      configSet: SelectableButton,
      configValues: {
        unselected: {
          style: {
            base: {
              padding: '4px 8px',
              justifyContent: 'start',
              alignItems: 'center',
            },
          },
        },
        selected: {
          style: {
            base: {
              padding: '4px 8px',
              justifyContent: 'start',
              alignItems: 'center',
            },
          },
        },
      },
    },
    regularLabel: {
      configSet: Text,
      configValues: {},
    },
    compactContainer: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        itemSpacing: '20px',
        style: {
          flexWrap: 'wrap',
          flexDirection: 'column',
        },
      },
    },
    compactItem: {
      configSet: SelectableButton,
      configValues: {
        unselected: {
          style: {
            base: {
              padding: '4px 8px',
              flexGrow: 0,
              flexShrink: 0,
              flexBasis: '50%',
              alignItems: 'center',
            },
          },
        },
        selected: {
          style: {
            base: {
              padding: '4px 8px',
              flexGrow: 0,
              flexShrink: 0,
              flexBasis: '50%',
              alignItems: 'center',
            },
          },
        },
      },
    },
    compactLabel: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
  },
  meta: {
    extendable: false,
  },
}
